import React, { useEffect, useState } from 'react';
import BetModal from '../Modals/BetModal';
import useSpeechToText from 'react-hook-speech-to-text';
import { FaMicrophone, FaMicrophoneSlash } from 'react-icons/fa';
import { BetVoiceResponseModel } from 'models/game';
import { showErrorModal } from 'components/Modals/CommonModals';
import oddsApi from 'api/oddsApi';
import { useAppTranslation, useErrTranslation } from 'app/hooks';

interface VoiceBetButtonProps {}

const VoiceBetButton: React.FunctionComponent<VoiceBetButtonProps> = (props) => {
  const [searchText, setSearchText] = useState<string>('');
  const [gameBet, setGameBet] = useState<BetVoiceResponseModel | null>(null);
  const t = useAppTranslation();
  const et = useErrTranslation();
  const { isRecording, results, setResults, startSpeechToText, stopSpeechToText } = useSpeechToText(
    {
      continuous: false,
      useLegacyResults: false,
      googleApiKey: 'AIzaSyAeSHMbVsToD_ydi5FR7HQc_yuMMYdE49A',
      googleCloudRecognitionConfig: {
        languageCode: 'en-US',
      },
      useOnlyGoogleCloud: true,
    },
  );
  const listenContinuously = () => {
    setResults([]);
    startSpeechToText();
  };

  const cancelListen = () => {
    stopSpeechToText();
  };

  const resetSearch = () => {
    setSearchText('');
  };

  useEffect(() => {
    if (results && results.length && (results[0] as any).transcript !== '') {
      setSearchText((results[0] as any).transcript);
    }
  }, [results]);

  useEffect(() => {
    searchBet();
  }, [searchText]);

  const handleRecord = () => {
    isRecording ? cancelListen() : listenContinuously();
  };

  const searchBet = async () => {
    if (searchText !== '') {
      const { ok, body, error } = await oddsApi.voiceBet({
        message: searchText,
      });
      if (ok && body) {
        setGameBet(body);
      }
      if (error) {
        const onOk = () => {
          setSearchText('');
        };
        showErrorModal({
          content: et(error.message),
          onOk,
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      }
      resetSearch();
    }
  };

  const closeModal = () => {
    setGameBet(null);
    resetSearch();
  };
  return (
    <>
      {/* <div className="bet-voice__input" onClick={handleRecord}>
        <span>{t('common.bet-voice')}</span>
        {isRecording ? (
          <FaMicrophone className="search__icon" />
        ) : (
          <FaMicrophoneSlash className="search__icon" />
        )}
      </div> */}
      {gameBet && (
        <BetModal
          className="common-modal deposit-modal"
          title={t('bet.placeBet')}
          visible={true}
          closeModal={closeModal}
          bet={gameBet}
        />
      )}
    </>
  );
};

export default VoiceBetButton;
